import { TDoppioPlayerConfig } from '@streaming/doppio-player';
import { IVideoElementControllerProps, TDeepPartial } from '@streaming/mouflon-utils';
import { IRistrettoPlayerConfig } from '@streaming/ristretto-player';

export enum EPlayerType {
  HLS = 'hls',
  WEBRTC = 'webrtc',
  BROADCAST = 'broadcast',
  NATIVE = 'native',
  UNKNOWN = 'unknown',
}

export const AVAILABLE_PLAYER_TYPES: EPlayerType[] = [
  EPlayerType.HLS,
  EPlayerType.BROADCAST,
  EPlayerType.WEBRTC,
  EPlayerType.NATIVE,
  EPlayerType.UNKNOWN,
];

export enum EPlaybackState {
  IDLE = 'idle',
  LOADING = 'loading',
  PAUSED = 'paused',
  PLAYING = 'playing',
  ERROR = 'error',
}

export interface IStreamConfig {
  HLSStreamUrl?: string;
  WebRTCSignallingUrl?: string;
  WebRTCStreamId?: string;
  WebRTCPublishCustomData?: Record<string, unknown>;
  WebRTCACLToken?: string;
  NativeStreamURL?: string;
  MediaStream?: MediaStream;
}

export interface INativePlayerConfig {
  addFallbackKey?: boolean;
}

export interface IPlayerCommonConfig {
  videoControllerConfig?: IVideoElementControllerProps;
  hlsConfig?: TDeepPartial<TDoppioPlayerConfig>;
  webRTCConfig?: TDeepPartial<IRistrettoPlayerConfig>;
  nativeConfig?: TDeepPartial<INativePlayerConfig>;

  persistent?: boolean;
  establishWSOnStart?: boolean;
}

export type TPlayerConfigPartial = IPlayerCommonConfig;

export type TMediaStream = string | MediaStream | MediaSource;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TAdditionalFields = Record<string, any>;

export type TResolutionV2 = {
  name: string;
  bitrate?: number;
  width?: number;
  height?: number;
  url?: string;
};

export type TPlayerError = {
  error: Error;
  errorType?: EPlayerErrorType;
  isFatal?: boolean;
  playerType: EPlayerType;
};

export enum EPlayerErrorType {
  BROADCAST_NOT_SUPPORTED_BY_BROWSER = 'broadcastNotSupportedByBrowser',
}
